import React from "react";
import { TimelineProps, useTimeline } from "./useTimeline";
import { TimelineProvider } from "./TimelineContext";

const Timeline: React.FC<TimelineProps> = (props) => {
  const { getTimelineProps } = useTimeline(props);
  const { variant, isConnected, ...rest } = getTimelineProps();

  return (
    <TimelineProvider variant={variant} isConnected={isConnected}>
      <div {...rest} />
    </TimelineProvider>
  );
};

export default Timeline;
